import React, { useState } from "react";
import "./EssenceTypes.scss";
import { Link } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { Box, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { FormattedMessage } from "react-intl";
import { buildSrcSet } from "../../utils/imageSrcSet";

const COLLAPSED_COUNT = 6;
const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
// Tiles are full width on phones and at most half the grid on larger screens.
const TILE_SIZES = "(max-width: 767px) 100vw, 50vw";

const EssenceTypes = () => {
    const { error, loading, data } = useFetch(`/sub-categories?populate=*`);
    const [expanded, setExpanded] = useState(false);

    if (loading || error || !data || data.length === 0) return null;

    const canCollapse = data.length > COLLAPSED_COUNT;
    const visibleEssences = expanded ? data : data.slice(0, COLLAPSED_COUNT);

    return (
        <Box component="section" sx={{ bgcolor: "background.default" }}>

            <div className="section-heading" style={{ marginTop: "clamp(80px, 10vw, 140px)" }}>
                <span className="eyebrow">
                    <FormattedMessage id="essences_eyebrow" defaultMessage="Rodziny zapachowe" />
                </span>
                <h2 className="title">
                    <FormattedMessage id="essences_title" defaultMessage="Odkryj esencję dla siebie" />
                </h2>
                <span className="rule" />
            </div>
            <div className={`essence-types-grid parent${expanded ? " expanded" : ""}`}>

                {visibleEssences.map((essence) => (
                    <div className="essence-item" key={essence.id}>
                        <img
                            src={UPLOAD_URL + (essence?.img?.formats?.medium?.url || essence?.img?.url)}
                            srcSet={buildSrcSet(essence?.img)}
                            sizes={TILE_SIZES}
                            alt={essence.title}
                            loading="eager"
                            decoding="async"
                        />
                        <Link
                            className="link"
                            to={`/products/essence/${essence.title.toLowerCase()}`}
                        >
                            <span className="title">{essence.title}</span>
                        </Link>
                    </div>
                ))}
            </div>

            {canCollapse && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 5, mb: 4, bgcolor: "background.default" }}>
                    <Button
                        variant="outlined"
                        onClick={() => setExpanded((prev) => !prev)}
                        aria-expanded={expanded}
                        endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    >
                        {expanded
                            ? <FormattedMessage id="essences_show_less" defaultMessage="Pokaż mniej" />
                            : <FormattedMessage id="essences_show_more" defaultMessage="Pokaż więcej" />}
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default EssenceTypes;
